<div bsModal #acceptGoogle="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-hidden="true"
                    style="position:absolute; right:20px;">&times;</button>
                <h4 class="modal-title">Registro con Google</h4>
            </div>
            <div class="modal-body f12" style="font-size: 16px; color:#333333;">
                <p>Asegúrate de conocer tu clave de cuenta Google, si no la recuerdas te recomendamos <strong>Crear tu
                        cuenta</strong> completando el formulario con un correo al que puedas acceder.</p>
            </div>
            <div class="modal-footer">
                <a class="btn btn-default btn-sm" (click)="closeModal()">Crear cuenta</a>
                <button class="btn btn-success btn-sm mensaje-aceptar-terminos" (click)="aceptarGoogle()"
                    data-dismiss="modal">Registro con Google</button>
            </div>
        </div>
    </div>
</div>